import { useDialogStore } from "../..//state/dialog-store";
import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

const useUnsavedChangesBlocker = (condition: boolean) => {
  const { setDialog } = useDialogStore();
  const blocker = useBlocker(condition);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setDialog({
        title: "Unsaved changes",
        description:
          "You have unsaved changes. Are you sure you want to leave?",
        confirmText: "Leave",
        cancelText: "Cancel",
        withCancelAction: true,
        onConfirm: async (onClose) => {
          onClose();
          blocker.proceed();
        },
        onClose: async () => {
          blocker.reset();
        },
      });
    }
  }, [blocker]);

  return blocker;
};

export default useUnsavedChangesBlocker;
